<template>
  <div class="sales-table">
    <el-dropdown @command="handleCommand" trigger="click">
      <span class="el-dropdown-link">
        {{dropTitle}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">经销商数据</el-dropdown-item>
          <el-dropdown-item command="b">型号数据</el-dropdown-item>
          <el-dropdown-item command="c">销售员数据</el-dropdown-item>
        </el-dropdown-menu>

 </el-dropdown>
 <div class="table">
   <el-table
     :data="tableData3"
     height="500"
     style="width: 100%" class="table-content">
     <el-table-column
       prop="name"
       :label="title"
       width="300">
     </el-table-column>
     <el-table-column
       prop="sales"
       label="销量"
       width="180">
     </el-table-column>
   </el-table>
 </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData3: [],
        dropTitle: "经销商数据",
        title: "经销商名称"
      }
    },
    created() {
      this.$nextTick(function() {
        this.test()
      })
    },
    methods: {

      test() {
        var data = []
        this.dropTitle = '经销商数据'
        this.title = '经销商名称'
        for (var i = 0; i < 100; i++) {
          data.push({'name': '经销商' + i, 'sales': this.randomValue()})
        }
        this.tableData3 = data.sort(
          function(obj1, obj2) {
            return obj2['sales'] - obj1['sales']
          }
        )
      },
      test1() {
        var data = []
        this.dropTitle = '型号数据'
        this.title = '型号名称'
        for (var i = 0; i < 100; i++) {
          data.push({'name': 'A005' + i, 'sales': this.randomValue()})
        }
        this.tableData3 = data.sort(
          function(obj1, obj2) {
            return obj2['sales'] - obj1['sales']
          }
        )
      },

      test2() {
        var data = []
        this.dropTitle = '销售员数据'
        this.title = '销售员名称'
        for (var i = 0; i < 100; i++) {
          data.push({'name': '销售员' + i, 'sales': this.randomValue()})
        }
        this.tableData3 = data.sort(
          function(obj1, obj2) {
            return obj2['sales'] - obj1['sales']
          }
        )
      },

      randomValue() {
        return Math.round(Math.random() * 1000)
      },
      handleCommand(command) {
        if (command == 'a') {
          this.test()
        }else if (command == 'b') {
          this.test1()
        }else {
          this.test2()
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .el-dropdown-link {
    font-size: 20px;
    margin-left: 20px;
  }
  .table {
    width: 50%;
    height:  550px;
    margin-top: 20px;
    margin-left: 30px;
    border: 1px solid #ebebeb;
    border-radius: 3px;
    transition: .2s;
    .table_content {
      margin: 20px auto;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/index/data-analysis/sales/sales-table.vue